import {
  addDays,
  differenceInCalendarDays,
  isValid,
  parseISO,
  startOfDay,
} from "date-fns";

export const calculateCommunicationDeadline = (
  communication,
  companyData,
  now = new Date(),
) => {
  const { date, solveDate, extendedDate, type, risk } = communication || {};
  const dateValue = extendedDate || date;

  if (!dateValue) {
    return null;
  }

  const parsedDate = parseISO(dateValue);
  if (!isValid(parsedDate)) {
    return null;
  }

  if (solveDate) {
    const solvedAt = startOfDay(parseISO(solveDate));
    if (!isValid(solvedAt)) {
      return null;
    }

    const createdAt = startOfDay(parseISO(date));
    return {
      days: differenceInCalendarDays(solvedAt, createdAt),
      colors: { bg: "bg-gray-300", text: "text-black" },
      limitDate: solvedAt,
      resolved: true,
    };
  }

  let daysToAdd = 90;

  if (
    type === "consultation" &&
    companyData?.consultationRiskSolveTimeLimits &&
    risk
  ) {
    const riskLimits = companyData.consultationRiskSolveTimeLimits;
    daysToAdd =
      riskLimits[risk] !== undefined
        ? riskLimits[risk]
        : (companyData?.altSolveTimeLimit || 90);
  } else if (
    type === "complaint" &&
    companyData?.complaintRiskSolveTimeLimits &&
    risk
  ) {
    const riskLimits = companyData.complaintRiskSolveTimeLimits;
    daysToAdd =
      riskLimits[risk] !== undefined
        ? riskLimits[risk]
        : (companyData?.solveTimeLimit || 90);
  } else {
    daysToAdd =
      type === "consultation"
        ? (companyData?.altSolveTimeLimit || 90)
        : (companyData?.solveTimeLimit || 90);
  }

  const startDate = startOfDay(parsedDate);
  const limitDate = addDays(startDate, daysToAdd);
  const today = startOfDay(now);
  const days = Math.max(differenceInCalendarDays(limitDate, today), 0);
  const [greenLimit, yellowLimit] = companyData?.dateLimitColors || [60, 30];
  const colors =
    days > greenLimit
      ? { bg: "bg-green-500", text: "text-black" }
      : days > yellowLimit
        ? { bg: "bg-yellow-500", text: "text-black" }
        : { bg: "bg-red-500", text: "text-white" };

  return {
    days,
    colors,
    daysToAdd,
    limitDate,
    resolved: false,
  };
};
